import { QUALIFICATION_STATUS } from "../enums/incentive-enums";
import type { TagColor } from "../leaf/LeafTag/LeafTag";

/**
 * Maps qualification statuses to LeafTag color variants.
 * Used for consistent status tag display across incentive pages.
 */
export const STATUS_TAG_VARIANT: Partial<Record<QUALIFICATION_STATUS, TagColor>> = {
  [QUALIFICATION_STATUS.QUALIFIED]: "green",
  [QUALIFICATION_STATUS.TRACKING]: "purple",
  [QUALIFICATION_STATUS.NOT_QUALIFIED]: "gray",
};

/**
 * Maps qualification statuses to content/translation keys.
 * Used for consistent status label display across incentive pages.
 */
export const STATUS_CONTENT_KEY: Partial<Record<QUALIFICATION_STATUS, string>> = {
  [QUALIFICATION_STATUS.QUALIFIED]: "achievedTag",
  [QUALIFICATION_STATUS.TRACKING]: "onTrackTag",
  [QUALIFICATION_STATUS.NOT_QUALIFIED]: "notTracking",
};

export const getStatusTagVariant = (status: string): TagColor => {
  return STATUS_TAG_VARIANT[status as QUALIFICATION_STATUS] ?? "gray";
};

export const getStatusContentKey = (status: string): string => {
  return STATUS_CONTENT_KEY[status as QUALIFICATION_STATUS] ?? "notTracking";
};
